const MODEL_VIEWER_SRC = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';

let modelViewerLoader;

function loadModelViewer() {
  if (customElements.get('model-viewer')) {
    return Promise.resolve();
  }
  if (modelViewerLoader) {
    return modelViewerLoader;
  }
  modelViewerLoader = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'module';
    script.src = MODEL_VIEWER_SRC;
    script.onload = () => resolve();
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return modelViewerLoader;
}

function activateViewer(host) {
  if (!host || host.dataset.ready === 'true') return;
  const src = host.dataset.src;
  if (!src) return;

  host.dataset.ready = 'true';
  loadModelViewer().then(() => {
    if (!customElements.get('model-viewer')) {
      return customElements.whenDefined('model-viewer');
    }
  }).then(() => {
    const viewer = document.createElement('model-viewer');
    viewer.setAttribute('src', src);
    viewer.setAttribute('alt', host.dataset.alt || '');
    viewer.setAttribute('camera-controls', '');
    viewer.setAttribute('touch-action', 'pan-y');
    viewer.setAttribute('shadow-intensity', '1');
    viewer.setAttribute('exposure', '1');
    viewer.setAttribute('interaction-prompt', 'auto');
    viewer.setAttribute('ar', '');
    viewer.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
    viewer.setAttribute('loading', 'eager');
    if (host.dataset.poster) viewer.setAttribute('poster', host.dataset.poster);
    if (host.dataset.iosSrc) viewer.setAttribute('ios-src', host.dataset.iosSrc);
    if (host.dataset.animation) viewer.setAttribute('animation-name', host.dataset.animation);
    if (host.dataset.autoplay === 'true') viewer.setAttribute('autoplay', '');
    viewer.addEventListener('load', () => host.classList.add('is-ready'), { once: true });
    host.appendChild(viewer);
  }).catch(() => {
    host.dataset.ready = 'false';
  });
}

function observeViewers() {
  const nodes = document.querySelectorAll('lb-model-viewer[data-src]');
  if (!nodes.length) return;

  if (!('IntersectionObserver' in window)) {
    nodes.forEach(activateViewer);
    return;
  }

  const observer = new IntersectionObserver((entries, current) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      activateViewer(entry.target);
      current.unobserve(entry.target);
    });
  }, { rootMargin: '200px 0px' });

  nodes.forEach((node) => observer.observe(node));
}

function goToGallery3d(root) {
  const scope = root || document;
  const thumb = scope.querySelector('.hdt-thumbnail__media[data-media-type="model-custom"], .hdt-thumbnail__media[data-media-type="model"]');
  if (thumb) {
    thumb.click();
    return true;
  }
  const slide = scope.querySelector('.hdt-product__media-item[data-media-type="model-custom"], .hdt-product__media-item[data-media-type="model"]');
  if (slide) {
    slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  }
  return false;
}

function bindOpenButtons() {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-lb-open-3d]');
    if (!button) return;
    event.preventDefault();
    const gallery = button.closest('hdt-product-media');
    if (goToGallery3d(gallery)) {
      const viewer = (gallery || document).querySelector('lb-model-viewer[data-src]');
      activateViewer(viewer);
      return;
    }
    const section = document.getElementById('lb-product-3d');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'center' });
      activateViewer(section.querySelector('lb-model-viewer[data-src]'));
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  observeViewers();
  bindOpenButtons();
});

document.addEventListener('shopify:section:load', observeViewers);
